<template>
    <v-card class="pa-3 ma-md-3">
        <loader v-if="isloading"></loader>

        <v-toolbar flat color="#1d2735" dark>
            <v-icon class="white--text" style="font-size: 45px"
                >mdi-account-supervisor-circle</v-icon
            >
            <pre><v-toolbar-title><h2>Comisiones de los agentes</h2></v-toolbar-title></pre>
        </v-toolbar>
        <v-row>
            <v-col cols="3">
                <date-select label="Fecha desde" v-model="filters.fecha_desde">
                </date-select>
            </v-col>
            <v-col cols="3">
                <date-select label="Fecha hasta" v-model="filters.fecha_hasta">
                </date-select>
            </v-col>
            <v-col cols="3">
                <v-autocomplete
                    label="Agente"
                    :items="Agentes"
                    v-model="filters.id_agente"
                    item-text="nombre"
                    item-value="id"
                >
                </v-autocomplete>
            </v-col>
            <v-col cols="3">
                <v-btn
                    @click="getAgentesComisiones"
                    color="primary"
                    class="white--text"
                    >Filtrar</v-btn
                >
            </v-col>
        </v-row>
        <v-data-table
            :item-class="
                () => {
                    return 'pointer';
                }
            "
            @click:row="
                (item) => {
                    abonos = item.abonos;
                    dialog = true;
                    //$router.push(`/guardar-agente?id=${item.id}`);
                }
            "
            dense
            :headers="headers"
            :items="comisiones"
            :search="search"
            :items-per-page="15"
            item-key="id"
            class="elevation-1"
            :sort-by="['nombre']"
            :sort-desc="[false]"
        >
        </v-data-table>
        <v-dialog v-model="dialog" max-width="600px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Abonos
                </v-card-title>
                <v-card-text style="text-align: center">
                    <v-data-table
                        dense
                        :headers="headers_abonos"
                        :items="abonos"
                        :search="search"
                        :items-per-page="15"
                        item-key="id"
                        class="elevation-1"
                        :sort-by="['nombre']"
                        :sort-desc="[false]"
                    >
                        <template v-slot:item.abono="{ item }">
                            {{ item.abono | format_precio }}</template
                        >
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-card>
</template>
<script>
export default {
    data() {
        return {
            filters: {
                fecha_desde: null,
                fecha_hasta: null,
                id_agente: null,
            },
            search: "",
            headers: [
                { text: "Agente", value: "agente", sortable: false },
                { text: "Mes", value: "mes", sortable: false },
                { text: "Año", value: "year", sortable: false },
                { text: "Importe", value: "importe", sortable: false },
                { text: "% Comisión", value: "comision", sortable: false },
                {
                    text: "Importe comisión",
                    value: "importe_comision",
                    sortable: false,
                },
            ],
            headers_abonos: [
                { text: "Cliente", value: "cliente", sortable: false },

                { text: "Presupuesto", value: "presupuesto", sortable: false },
                { text: "Tipo", value: "tipo", sortable: false },
                { text: "Nº Factura", value: "nro", sortable: false },
                { text: "Abono", value: "abono", sortable: false },
            ],

            abonos: [],
            Agentes: [],
            comisiones: [],
            selectedItem: 0,
            dialog: false,
        };
    },
    created() {
        let date = new Date();
        // Get the end of the month
        const endOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        this.filters.fecha_hasta = endOfMonth.toISOString().split("T")[0];
        this.filters.fecha_desde = `${date.getFullYear()}-${date.getMonth()}-01`;

        this.getAgentesComisiones();
        this.getAgentes();
    },
    methods: {
        getAgentesComisiones() {
            let search = "";
            if (this.filters.fecha_desde) {
                search += `&desde=${this.filters.fecha_desde}`;
            }
            if (this.filters.fecha_desde) {
                search += `&hasta=${this.filters.fecha_hasta}`;
            }
            if (this.filters.id_agente) {
                search += `&agente=${this.filters.id_agente}`;
            }
            axios.get(`api/get-agentes-comisiones?${search}`).then(
                (res) => {
                    this.comisiones = res.data;
                },
                (err) => {
                    this.$custom_error("Error consultando las comisiones");
                }
            );
        },
        getAgentes() {
            axios.get(`api/get-agentes`).then(
                (res) => {
                    this.Agentes = res.data.Agentes;
                },
                (err) => {
                    this.$custom_error("Error consultando los agentes");
                }
            );
        },
    },
    computed: {
        isloading: function () {
            return this.$store.getters.getloading;
        },
    },
};
</script>
